export function sortByProp<K extends string>(
  prop: K
): <T extends Record<K, unknown>>(a: T, b: T) => number {
  return (a, b) => {
    const av = a[prop];
    const bv = b[prop];
    if (av == null && bv == null) return 0;
    if (av == null) return 1;
    if (bv == null) return -1;
    return String(av).localeCompare(String(bv), undefined, { numeric: true });
  };
}
